module.exports = __webpack_public_path__ + "img/trusted.df49f502.svg";